import React from "react";
import "./FrequentlyVisitedMakes.css";


import amg from "../assets/makes/LOGO 1.png";
import mercedes from "../assets/makes/LOGO 2.png";
import tesla from "../assets/makes/LOGO 3.png";
import porsche from "../assets/makes/LOGO 4.png";
import bentley from "../assets/makes/LOGO 5.png";
import landrover from "../assets/makes/LOGO 6.png";
import sv from "../assets/makes/LOGO 7.png";
import volkswagen from "../assets/makes/LOGO 8.png";
import rs from "../assets/makes/LOGO 9.png";
import ferrari from "../assets/makes/LOGO 10.png";
import ford from "../assets/makes/LOGO 11.png";
import mazda from "../assets/makes/LOGO 12.png";
import toyota from "../assets/makes/LOGO 13.png";
import nissan from "../assets/makes/LOGO 14.png";

const makes = [
  [amg, mercedes, tesla, porsche, bentley],
  [landrover, sv, volkswagen, sv, rs],
  [ferrari, ford, mazda, toyota, nissan],
];

const altTexts = [
  ["AMG", "Mercedes", "Tesla", "Porsche", "Bentley"],
  ["Land Rover", "SV", "Volkswagen", "SV", "RS"],
  ["Ferrari", "Ford", "Mazda", "Toyota", "Nissan"],
];


const FrequentlyVisitedMakes = () => (
  <div className="frequently-makes-section">
    <h2 className="frequently-makes-title">
      Our Frequently Visited Makes & Models
    </h2>
    <div className="frequently-makes-grid">
      {makes.map((row, rowIdx) =>
        row.map((logo, colIdx) => (
          <div className="frequently-make-cell" key={altTexts[rowIdx][colIdx]}>
            <img
              src={logo}
              alt={altTexts[rowIdx][colIdx]}
              className="frequently-make-logo"
            />
          </div>
        ))
      )}
    </div>
  </div>
);

export default FrequentlyVisitedMakes; 